import {
	useTable,
	useGlobalFilter,
	useFilters,
	useSortBy,
	usePagination,
	TableOptions,
	useBlockLayout,
} from 'react-table';

import UserActionsTable from './UserActionsTable'
import UserActionsFilters from './UserActionsFilters';
import UserActionsPagination from './UserActionsPagination';
import './UserActionsTable.scss';

interface TableContainerProps {
	columns: any;
	data: any;
	loading?: any;
	error?: any;
	presetFilter?: any;
}

const UserActionsTableContainer: React.FC<TableContainerProps> = ({
	columns,
	data,
	loading,
	error,
	presetFilter = null,
}) => {

	const tableOptions: TableOptions<Object> = {
		columns,
		data,
		initialState: { pageSize: 5, hiddenColumns: ['id'] },
	};

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		state,
		setAllFilters,
		page,
		rows,
		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,
		setPageSize,
	} = useTable(
		tableOptions,
		useGlobalFilter,
		useFilters,
		useSortBy,
		usePagination,
		useBlockLayout
	);

	return (
		<>
			<UserActionsFilters
				headerGroups={headerGroups}
				setAllFilters={setAllFilters}
				loading={loading}
				presetFilter={presetFilter}
			></UserActionsFilters>

			{!loading && !error && (
				<>
					<UserActionsTable
						getTableProps={getTableProps}
						headerGroups={headerGroups}
						getTableBodyProps={getTableBodyProps}
						page={page}
						prepareRow={prepareRow}
						resultCount={rows.length}
					></UserActionsTable>

					<UserActionsPagination
						gotoPage={gotoPage}
						canPreviousPage={canPreviousPage}
						previousPage={previousPage}
						nextPage={nextPage}
						canNextPage={canNextPage}
						pageCount={pageCount}
						state={state}
						pageOptions={pageOptions}
						setPageSize={setPageSize}
					></UserActionsPagination>
				</>
			)}

			{error && (
				<div className="table-error-message">{error.message}</div>
			)}
		</>
	);
};

export default UserActionsTableContainer;
